import * as React from 'react';

function SvgLongtailProcessConfirmation(props) {
  return (
    <svg width={21} height={21} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h21v21H0z" />
        <path d="M10.5 10.184c5.599 0 10.15 4.065 10.15 9.102 0 1.182-2.8 1.553-9.752 1.57H10.5C3.253 20.863.35 20.5.35 19.287c0-5.037 4.551-9.102 10.15-9.102zm0 1.442c-4.659 0-8.47 3.225-8.697 7.277.066.017.141.035.224.052.466.096 1.162.182 2.048.253 1.683.135 3.99.208 6.425.207 2.427-.002 4.737-.078 6.425-.214.886-.07 1.583-.157 2.049-.252.082-.017.157-.034.223-.051-.23-4.05-4.04-7.272-8.697-7.272zm0 .056a5.768 5.768 0 110-11.537 5.768 5.768 0 010 11.537zm0-1.553a4.215 4.215 0 100-8.431 4.215 4.215 0 000 8.43z" />
      </g>
    </svg>
  );
}

export default SvgLongtailProcessConfirmation;
